import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { rem } from 'polished';
import SaveYourProjectAndContinueTemplate from './SaveYourProjectAndContinueTemplate';
export const SaveYourProjectAndContinueStyled = styled(SaveYourProjectAndContinueTemplate)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 ${rem(10)} 0 ${rem(10)};
    padding: ${rem('32px')} 0;

    .button {
        margin-top: ${rem('8px')};
        button {
            min-height: 50px;
        }
    }

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;

        .button {
            width: fit-content;
            margin-top: unset;
            min-width: ${rem('300px')};
            &:nth-child(odd) {
                margin-right: 8px;
            }

            &:nth-child(even) {
                margin-left: 8px;
            }
        }
    }
`;
